import React, { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

export default function HeroSection({ userName }) {
  const [greeting, setGreeting] = useState('');
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const now = new Date();
    const hours = now.getHours();

    let greetingText = '';
    if (hours < 12) {
      greetingText = 'Good morning';
    } else if (hours < 18) {
      greetingText = 'Good afternoon';
    } else {
      greetingText = 'Good evening';
    }

    if (userName) {
      const firstName = userName.split(' ')[0];
      greetingText += `, ${firstName}`;
    }

    setGreeting(greetingText);

    const dateString = now.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
    setCurrentDate(dateString);
  }, [userName]);

  return (
    <div className="pt-16 pb-6 px-10">
      <div className="max-w-3xl mx-auto animate-fade-in">
        <div className="flex justify-end mb-8">
          <div className="text-sm text-muted-foreground">
            {currentDate}
          </div>
        </div>

        <div className="flex items-center justify-center gap-2">
          <img
            src="https://cdn.magicpatterns.com/uploads/5MtA4tXkVebawPHLJj8Kzz/Drop_Anchor.svg"
            alt="Drop Anchor Illustration"
            className="w-48 h-auto"
            draggable={false}
          />

          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-foreground mb-2 drop-shadow-sm">
              {greeting}
            </h1>
            <p className="text-lg text-muted-foreground">
              Drop anchor on what needs clarity
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
